import { FooterMessage } from "../../pages/CleanroomCreateInstall/cleanroomCreateInstall.types";
import BarChartSVG from "../../../assets/bar_chart.svg?react";
import LineChartSVG from "../../../assets/line_chart.svg?react";
import PieChartSVG from "../../../assets/pie_chart.svg?react";
import TableSVG from "../../../assets/table.svg?react";

export enum OAUTH_TYPE {
    SNOWFLAKE = "SNOWFLAKE",
    AUTH0 = "AUTH0",
}

export enum APPLICATION_IDS {
    AUDIENCE_OVERLAP_AND_SEGMENTATION = "audience_overlap_analysis",
    REACH_AND_FREQUENCY = "reach_and_frequency",
    AUDIENCE_LOOKALIKE_MODELING = "audience_lookalike_modeling",
    LAST_TOUCH_ATTRIBUTION = "conversion_tracking",
    INVENTORY_FORECASTING = "inventory_forecasting_and_planning",
    SQL_QUERY = "overlap_analysis",
    CUSTOM_ANALYSIS = "custom_analysis",
    // Until deprecation of Lookalike Modeling
    CUSTOM_TEMPLATE_AUDIENCE_LOOKALIKE_MODELING = "custom_template_audience_lookalike_modeling",
}

export enum PRIVILEGES {
    ALL = "ALL",
    MANAGE_CLEANROOMS = "MANAGE_CLEANROOMS",
    MANAGE_DCR_PROFILE_AND_FEATURES = "MANAGE_DCR_PROFILE_AND_FEATURES",
    MANAGE_DCR_CONNECTORS = "MANAGE_DCR_CONNECTORS",
    MANAGE_DCR_COLLABORATORS = "MANAGE_DCR_COLLABORATORS",
}

export enum MenuIds {
    Cleanrooms = "cleanrooms",
    Connectors = "connector",
    DeveloperEdition = "developer_edition",
    Account = "Account",
    Analysis = "analysis",
    AccountGovernance = "account-governance",
    AccountBilling = "account-billing",
    Logout = "logout",
    HelpCenter = "help",
    AccountProfile = "profile",
    Admin = "admin",
    Collaborators = "collaborators",
}

export const TransUnion_IdentifierType = {
    Address: "Address",
    Email: "Email",
    Phone: "Phone",
    IPAddress: "IP Address",
    FirstName: "First Name",
    LastName: "Last Name",
    DateOfBirth: "Date of Birth",
    DeviceId: "Device ID",
};

export const STATUS_SEPARATOR = "~|~";

export const tablesWithNoJoinPolicyColumnsWarningMessage: FooterMessage = {
    type: "warning",
    content:
        "Tables must have a join policy column to be used in this template. Update join policy columns for disabled tables in the previous step.",
};

export const CLEANROOM_TYPES = {
    SNOWFLAKE: "SNOWFLAKE",
    AMC: "AMC",
    ADH: "ADH",
    DEV_MODE: "SNOWFLAKE_DEV_MODE",
};

export const PRIVACY_BUDGET = {
    privacy_budget_lower_bound: 1,
    privacy_budget_upper_bound: 10,
    epsilon_budget_lower_bound: 0.1,
    epsilon_budget_upper_bound: 1,
    threshold_budget_lower_bound: 0,
};

export enum THIRD_PARTY_IDENTITY_PROVIDER {
    LIVERAMP_IDENTITY_SOLUTION = "LIVERAMP_IDENTITY_SOLUTION",
    ACXIOM_IDENTITY_GENERATION = "ACXIOM_IDENTITY_GENERATION",
    ACXIOM_TRANSCODING = "ACXIOM_TRANSCODING",
    TRANSUNION_IDENTITY_GENERATION = "TRANSUNION_IDENTITY_GENERATION",
    TRADE_DESK = "trade_desk",
    GOOGLE_PAIR_DV360 = "GOOGLE_PAIR_DV360",
    MERKURY_IDENTITY_GENERATION = "MERKURY_IDENTITY_GENERATION",
    UID_2 = "UID_2.0",
    EXPERIAN = "EXPERIAN",
}

export enum TOGGLE_TYPE {
    TABLE = "TABLE",
    BAR_CHART = "BAR",
    LINE_CHART = "LINE",
    PIE_CHART = "PIE",
}

export const TOPN_OPTIONS = [
    { label: "Top 10", value: 10 },
    { label: "Top 5", value: 5 },
];

export const TOGGLE_OPTIONS = [
    { value: TOGGLE_TYPE.TABLE, icon: TableSVG },
    { value: TOGGLE_TYPE.BAR_CHART, icon: BarChartSVG },
    { value: TOGGLE_TYPE.LINE_CHART, icon: LineChartSVG },
    { value: TOGGLE_TYPE.PIE_CHART, icon: PieChartSVG },
];

export const SNOWFLAKE_UNQUOTED_ID_PATTERN = /^[a-zA-Z_][\w\$]{0,255}$/;
export const SNOWFLAKE_QUOTED_ID_PATTERN = /^"([^"]|""){1,255}"$/;

export const OAUTH_ERROR_MESSAGES = {
    INCORRECT_ACCOUNT_IDENTIFIER_FORMAT:
        "Invalid account identifier, please check the format.",
    NO_RESPONSE_FROM_SERVER:
        "The HTTP request validation failed, please try again.",
    INVALID_ACCOUNT_IDENTIFIER:
        "Invalid account identifier, account not found.",
    COULD_NOT_CREATE_SNOWFLAKE_CONNECTION:
        "Connection failed, please try again.",
    INVALID_TOKEN_RESPONSE:
        "Access token for Snowflake session is expired or invalid, please try logging in again.",
    TOKEN_REQUEST_FAILED:
        "Access token for Snowflake session is expired or invalid, please try logging in again.",
    UNRECOGNIZED_AUTH_TYPE: "Invalid Auth Type, contact support.",
    DIFFERENT_DEPLOYMENT:
        "Account identifier is for a different region. Please enter the correct region URL for the account. [Click here](<DYNAMIC_URL>) to redirect.",
    UNSUPPORTED_DEPLOYMENT:
        "The region is not supported in Snowflake Data Clean Rooms, please use a supported region URL.",
    SERVICE_USER_CONFIGURATION_ERROR:
        "Account setup is not complete, please ask ACCOUNTADMIN to complete the setup.",
    DEFAULT_WAREHOUSE_NOT_AVAILABLE:
        "The user does not have a default warehouse selected. Please add a default warehouse for the user and try again.",
    NETWORK_POLICY_EXCEPTION:
        "Network policy error, please ask your account administrator to setup the network policy for your access correctly.\n" +
        "\n" +
        "Incoming request is not allowed to access Snowflake. Contact your account administrator. For more information about this error, go to https://docs.snowflake.com/en/user-guide/cleanrooms/admin-tasks#configure-network-policies.",
};

export enum AUTH_TYPE {
    AUTH0 = "AUTH0",
    SNOWFLAKE = "SNOWFLAKE",
}

export const USER_CANCELLED_ACTION = "USER_CANCELLED_ACTION_MESSAGE";

export enum CLEANROOM_SIDE {
    PROVIDER = "PROVIDER",
    CONSUMER = "CONSUMER",
}

export const disabledAnalysesForInternalTest: APPLICATION_IDS[] = [
    APPLICATION_IDS.AUDIENCE_LOOKALIKE_MODELING,
    APPLICATION_IDS.REACH_AND_FREQUENCY,
    APPLICATION_IDS.LAST_TOUCH_ATTRIBUTION,
    APPLICATION_IDS.INVENTORY_FORECASTING,
];

export const enabledAnalysesForInternalTest: APPLICATION_IDS[] = [
    APPLICATION_IDS.AUDIENCE_OVERLAP_AND_SEGMENTATION,
    APPLICATION_IDS.SQL_QUERY,
];
